
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"door"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.47 10.31a.3.3 0 01-.298-.304.3.3 0 01.298-.303","stroke":"currentColor","stroke-width":"1.25"}}),_c('path',{attrs:{"d":"M7.469 10.31a.3.3 0 00.298-.304.3.3 0 00-.298-.303","stroke":"currentColor","stroke-width":"1.25"}}),_c('path',{attrs:{"d":"M13.14 2.707h3.582c.316 0 .62.128.844.355.224.228.35.536.35.858v12.128c0 .322-.126.63-.35.858a1.184 1.184 0 01-.844.355H13.14m-3.07 1.823l-7.162-1.003a.595.595 0 01-.367-.206.612.612 0 01-.143-.4V3.301a.612.612 0 01.136-.374.595.595 0 01.334-.208L10.03.924a.588.588 0 01.5.12.606.606 0 01.224.47v16.98a.607.607 0 01-.208.456.585.585 0 01-.476.134z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    